// Adjustトラッカー
const parameters = [];

// CVボタンをiOS、Android、その他で出し分け
const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) {
    return "Android";
  } else if (
    /iPhone|iPod|iPad/i.test(ua) ||
    (/macintosh/i.test(ua) && "ontouchend" in document)
  ) {
    return "iOS";
  }
  return "Other";
};
const os = getMobileOS();

const url = new URL(document.location).searchParams;
const branchNo = url.get("branch");
const result = parameters.find(({ branch }) => branch === branchNo);
const storeBtns = document.getElementsByClassName("p-btn-download-store");
const storeBtnsIos = document.querySelectorAll(".js-iOS-link");
const storeBtnsAndroid = document.querySelectorAll(".js-Android-link");
const thumbBtns = document.querySelectorAll(".p-btn-thumb");
const fixURL = "";
const newFixURL = "";
const iosFixURL = "";
const androidFixURL = "";
const unknownFixURL = "";

if (result) {
  storeBtnsIos.forEach((el) => {
    el.setAttribute("href", iosFixURL);
  });
  storeBtnsAndroid.forEach((el) => {
    el.setAttribute("href", androidFixURL);
  });
  if (typeof result.href === "object") {
    let fixUrl = "";
    if (os === "Other") {
      fixUrl = result.href.pc ? result.href.pc : unknownFixURL;
    } else if (os === "iOS") {
      fixUrl = result.href.iOS ? result.href.iOS : iosFixURL;
    } else if (os === "Android") {
      fixUrl = result.href.Android ? result.href.Android : androidFixURL;
    }
    thumbBtns.forEach((el) => {
      el.setAttribute("href", fixUrl);
    });
  } else {
    for (const storeBtn of storeBtns) {
      storeBtn.setAttribute("href", result.href);
    }
    // ユニークIDがある場合（コンテンツサムネイルにAdjustURLを付与する場合）
    if (result.uniqueId) {
      if (result.traking) {
        thumbBtns.forEach((_, index) => {
          thumbBtns[index].setAttribute(
            "href",
            fixURL + result.uniqueId + newHrefThumbs[index] + result.traking
          );
        });
      } else {
        for (let i = 0; i < thumbBtns.length; i++) {
          thumbBtns[i].setAttribute(
            "href",
            fixURL + result.uniqueId + hrefThumbs[i]
          );
        }
      }
    }
  }
}

$(function () {
  $(".p-btn-thumb")
    .eq(0)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=1&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });
  $(".p-btn-thumb")
    .eq(1)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=2&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });
  $(".p-btn-thumb")
    .eq(2)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=3&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });
  $(".p-btn-thumb")
    .eq(3)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=4&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });
  $(".p-btn-thumb")
    .eq(4)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=5&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });
  $(".p-btn-thumb")
    .eq(5)
    .on("click", function (event) {
      event.preventDefault();
      window.open(
        "https://app-assets.au-5g.auone.jp/webplayvideo/1/index.html?cpid=35&groupno=1&sort_order=6&destinationurl=https%3A%2F%2Faushort.auone.jp%2Flp%2Findex.html",
        "_blank"
      );
    });

  // スムーススクロール
  $('a[href^="#"]').click(function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("#menu").removeClass("open");
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  const windowWidth = window.innerWidth;
  const viewTop = $("#provider").offset().top;
  // スクロールイベントを監視
  $(window).scroll(function () {
    var scrollPosition = $(this).scrollTop();
    if (scrollPosition >= viewTop) {
      $("#scroll_view_header").css("top", "56px");
    } else {
      if (windowWidth < 897) {
        $("#scroll_view_header").css("top", "-116px");
      } else {
        $("#scroll_view_header").css("top", "-155px");
      }
    }
  });

  let swiper = new Swiper(".swiper", {
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 2000,
    spaceBetween: 24,
    slidesPerView: "auto",
  });

  let au_short_swiper = new Swiper(".swiper_au_shorts", {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    speed: 1000,
    slidesPerView: 1,
  });

  $(".swiper_au_shorts").on("click", function () {
    au_short_swiper.slideNext();
  });

  $(window).on("load", function () {
    createImgFadeArea();
    uaJudge();
  });

  $(window).on("resize", function () {
    // windowリサイズ時width再取得
    const windowWidth = window.innerWidth;
    // windowリサイズ時既存のSwiperインスタンスを破棄
    swiper.destroy();
    if (windowWidth < 897) {
      preView = Math.floor(windowWidth / 158);
    } else {
      preView = Math.floor(windowWidth / 224);
    }

    swiper = new Swiper(".swiper", {
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 2000,
      spaceBetween: 24,
      slidesPerView: "auto",
    });

    au_short_swiper.destroy();
    au_short_swiper = new Swiper(".swiper_au_shorts", {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      speed: 1000,
      slidesPerView: 1,
    });
  });

  /*
   * key visualの画像フェードアニメーション
   */
  function createImgFadeArea() {
    let currentImageIndex = 0;
    const images = document.querySelectorAll(".fade_img");

    function showImage(index) {
      images.forEach((img) => img.classList.remove("active"));
      images[index].classList.add("active");
    }

    function nextSlide() {
      images[currentImageIndex].classList.remove("active");
      currentImageIndex = (currentImageIndex + 1) % images.length;
      images[currentImageIndex].classList.add("active");
    }

    showImage(currentImageIndex);

    // key visualの画像のフェードアニメーションのintervalを変更したい場合はここを修正
    setInterval(nextSlide, 3000);
  }

  /*
   * ユーザーエージェントボタンだしわけ
   */
  function uaJudge() {
    // ユーザーエージェント文字列を取得
    const userAgent = navigator.userAgent;

    // iOSかAndroidかを判別する関数
    function isIOS() {
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    }

    function isAndroid() {
      return /Android/.test(userAgent);
    }

    const elem_ios = document.getElementsByClassName("is_ios");
    const elem_android = document.getElementsByClassName("is_android");

    // ユーザーエージェントに基づいて異なる処理を実行
    if (isIOS()) {
      // iOSの場合の処理
      for (let i = 0; i < elem_ios.length; i++) {
        elem_ios[i].classList.add("active");
      }
      for (let i = 0; i < elem_android.length; i++) {
        elem_android[i].classList.remove("active");
      }
    } else if (isAndroid()) {
      for (let i = 0; i < elem_android.length; i++) {
        elem_android[i].classList.add("active");
      }
      for (let i = 0; i < elem_ios.length; i++) {
        elem_ios[i].classList.remove("active");
      }
    } else {
      // iOSでもAndroidでもない場合念の為考慮
      for (let i = 0; i < elem_android.length; i++) {
        elem_android[i].classList.add("active");
      }
      for (let i = 0; i < elem_ios.length; i++) {
        elem_ios[i].classList.add("active");
      }
    }
  }

  $(function () {
    $(".faq_q").on("click", function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("open", 200);
    });
    $("#hamburger_btn").on("click", function () {
      $("#menu").addClass("open");
    });
    $("#menu_close").on("click", function () {
      $("#menu").removeClass("open");
    });
    $("#to_campaign1").on("click", function () {
      $("#event").fadeIn();
      $(".content_wrap").scrollTop(0);
    });
    $("#to_campaign2").on("click", function () {
      $("#campaign").fadeIn();
      $(".content_wrap").scrollTop(0);
    });
    $("#to_campaign3").on("click", function () {
      $("#renewal_campaign").fadeIn();
      $(".content_wrap").scrollTop(0);
    });
    $(".event_close").on("click", function () {
      $("#event").fadeOut();
    });
    $(".campaign_close").on("click", function () {
      $("#campaign").fadeOut();
    });
    $(".renewal_campaign_close").on("click", function () {
      $("#renewal_campaign").fadeOut();
    });
  });
});

/**
 * ここから表示切り替え用のタイマーjs
 */

// const switchDate = new Date("YYYY/MM/DD hh:mm:ss"); //切り替え日時でDateオブジェクトを生成する
// const nowDate = new Date();

// // addClassでclass名を付与しそのclassに対してstyleで出し分ける
// if (switchDate <= nowDate) {
//   $("body").addClass(`class`);
// }
